import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageNWSL1 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Sam Coffey leaves Portland Thorns",
            author: "footballgirl",
            date: "January, 2026",
            image: "images/nwsl/1a.jpg",
            content: `<article>
  

  <p>Manchester City have completed the signing of United States women's national team midfielder Sam Coffey from Portland Thorns, with the transfer finalized in mid-January 2026. The move, initially reported as in its final stages, saw Coffey join Andrée Jeglertz's side on a three-and-a-half-year contract running until the summer of 2029, subject to international clearance.</p>

  <h2>Transfer Confirmation and Details</h2>
  <p>The deal represents a club-record fee for Manchester City Women, with sources confirming a base transfer amount of $875,000 (£651,000) plus add-ons. Coffey, aged 27, departs the NWSL after a decorated stint with Portland Thorns, where she served as captain and helped secure the 2022 NWSL Championship. She earned three NWSL Best XI First Team selections in 2022, 2023, and 2025, establishing herself as one of the league's premier defensive midfielders.</p>

  <p>Manchester City director of football Therese Sjögran welcomed the arrival, stating: <q>Sam's reputation as one of the world's best speaks for itself, and we're delighted she's chosen to come here ahead of other potential suitors.</q> The transfer underscores City's ambition to strengthen their midfield options amid a dominant WSL campaign, where they currently sit atop the table.</p>

  <h2>Player Background and Achievements</h2>
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
  <p>Sam Coffey has been a consistent performer for both club and country. With the USWNT, she remains a key figure under head coach Emma Hayes, featuring regularly despite squad experimentation in recent cycles. Her move to Europe marks her first professional stint outside the United States, following years of leadership in the NWSL. At Portland, she guided the team to the 2025 NWSL Play-Off semi-finals and was integral to their midfield stability.</p>

  <h2>Integration and Early Impact</h2>
  <p>Since joining in January, Coffey has quickly adapted to the WSL's intensity. In her first start, she anchored the midfield impressively during a commanding 6-0 victory, showcasing her composure on the ball and defensive discipline. Fans and analysts have praised her seamless transition, noting her ability to dictate tempo and protect the backline in high-pressing systems.</p>

  <h2>Tactical Fit</h2>
  <p>Coffey provides additional depth and quality to Manchester City's midfield unit, complementing existing stars like Yui Hasegawa. Her arrival offers a high-caliber option for the double pivot behind attacking talents such as Vivianne Miedema, ensuring stability even during international absences or rotation periods. Her experience as a holding midfielder aligns perfectly with Jeglertz's tactical demands for control and progression in possession-based play.</p>

  <h2>Future Outlook</h2>
  <p>As Manchester City push for their first WSL title in over a decade, Coffey's signing bolsters their credentials as genuine contenders. Her presence could prove decisive in tight matches against rivals like Arsenal and Chelsea. For Coffey, the move opens new opportunities on the European stage while maintaining her status in the USWNT setup ahead of future international commitments. The transfer highlights the growing financial power in women's football, with the January 2026 window setting records for international fees.</p>
</article>`,
            tags: ["NWSL", "Portland Thorns", "Man City", "Sam Coffey", "Transfers"],
            navIndices: { prev: 'wsl-9', next: 'nwsl-2' }
        });
    }

    init() {
        console.log('ArticlePageNWSL1 initialized');
        super.init();
    }

    render() {
        super.render();
        
        // Update Back Button Text and Behavior
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to NWSL
            `;
            
            // Replace with clone to remove old event listener (which went to top of page)
            // and attach new one that goes to #nwsl anchor
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'nwsl' } });
                this.element.dispatchEvent(event);
            });
        }

        // Update League Logo in the corner
        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_nwsl.png';
            leagueLogo.alt = 'NWSL';
        }
    }
}